import { authAPI } from '@/api/new-api'
import { BuildingUnit } from '@/models'

interface GetBuildingUnitsResponse {
  data: BuildingUnit[]
  count: number
  limit: number
  skip: number
}

export const GET_BUILDING_UNITS_BASE_QUERY_KEY = 'useGetBuildingUnits'

export const getBuildingUnits = async (
  data: { buildingId?: number; search?: string; limit?: number; skip?: number },
  signal?: AbortSignal,
): Promise<BuildingUnit[]> => {
  const response = await authAPI.get<GetBuildingUnitsResponse>('/unit', {
    params: {
      buildingId: data.buildingId,
      limit: data.limit,
      search: data.search,
      skip: data.skip ?? 0,
    },
    signal,
  })
  return response.data.data
}
